module.exports = __webpack_public_path__ + "img/CersoTearsInkBlack.30f9f080.png";